import React, { useState } from "react";
import "./Notifications.css";

function Notifications() {
  // Mock notifications data - replace with real data later
  const [notifications] = useState([
    {
      id: 1,
      title: "New User Registration",
      message: "A new user has registered on the platform",
      time: "5 minutes ago",
      date: "2024-01-15",
      read: false,
      type: "user"
    },
    {
      id: 2,
      title: "Payment Received",
      message: "Payment of ৳5,000 has been received from user ID: 12345",
      time: "1 hour ago",
      date: "2024-01-15",
      read: false,
      type: "payment"
    },
    {
      id: 3,
      title: "Withdrawal Request",
      message: "New withdrawal request of ৳2,500 is pending approval",
      time: "2 hours ago",
      date: "2024-01-15",
      read: false,
      type: "withdraw"
    },
    {
      id: 4,
      title: "System Update",
      message: "System maintenance scheduled for tonight at 2:00 AM",
      time: "1 day ago",
      date: "2024-01-14",
      read: true,
      type: "system"
    },
    {
      id: 5,
      title: "Support Ticket",
      message: "New support ticket #1234 has been created",
      time: "2 days ago",
      date: "2024-01-13",
      read: true,
      type: "support"
    },
    {
      id: 6,
      title: "Package Purchase",
      message: "User purchased Premium package for ৳10,000",
      time: "3 days ago",
      date: "2024-01-12",
      read: true,
      type: "payment"
    },
    {
      id: 7,
      title: "User Verification",
      message: "User verification completed successfully",
      time: "4 days ago",
      date: "2024-01-11",
      read: true,
      type: "user"
    },
    {
      id: 8,
      title: "Account Suspended",
      message: "User account has been suspended due to policy violation",
      time: "5 days ago",
      date: "2024-01-10",
      read: true,
      type: "system"
    }
  ]);

  const [filter, setFilter] = useState("all"); // all, unread, read

  const filteredNotifications = notifications.filter(notification => {
    if (filter === "unread") return !notification.read;
    if (filter === "read") return notification.read;
    return true;
  });

  const unreadCount = notifications.filter(n => !n.read).length;

  const getNotificationIcon = (type) => {
    switch(type) {
      case "user":
        return "person_add";
      case "payment":
        return "payment";
      case "withdraw":
        return "account_balance_wallet";
      case "system":
        return "settings";
      case "support":
        return "support_agent";
      default:
        return "notifications";
    }
  };

  const getNotificationColor = (type) => {
    switch(type) {
      case "user":
        return "#2196f3";
      case "payment":
        return "#4caf50";
      case "withdraw":
        return "#ff9800";
      case "system":
        return "#9c27b0";
      case "support":
        return "#f44336";
      default:
        return "#607d8b";
    }
  };

  const markAllAsRead = () => {
    // Functionality will be added later
    console.log("Mark all as read");
  };

  const markAsRead = (id) => {
    // Functionality will be added later
    console.log("Mark as read:", id);
  };

  return (
    <div className="notifications-page-container">
      <div className="notifications-header">
        <div className="notifications-header-left">
          <h1 className="notifications-page-title">Notifications</h1>
          <p className="notifications-page-subtitle">
            {unreadCount > 0 ? `${unreadCount} unread notifications` : "All caught up!"}
          </p>
        </div>
        <div className="notifications-header-right">
          {unreadCount > 0 && (
            <button className="notifications-mark-all-btn" onClick={markAllAsRead}>
              <span className="material-icons">done_all</span>
              Mark All as Read
            </button>
          )}
        </div>
      </div>

      <div className="notifications-filters">
        <button 
          className={`notification-filter-btn ${filter === "all" ? "active" : ""}`}
          onClick={() => setFilter("all")}
        >
          All ({notifications.length})
        </button>
        <button 
          className={`notification-filter-btn ${filter === "unread" ? "active" : ""}`}
          onClick={() => setFilter("unread")}
        >
          Unread ({unreadCount})
        </button>
        <button 
          className={`notification-filter-btn ${filter === "read" ? "active" : ""}`}
          onClick={() => setFilter("read")}
        >
          Read ({notifications.length - unreadCount})
        </button>
      </div>

      <div className="notifications-list-container">
        {filteredNotifications.length === 0 ? (
          <div className="notifications-empty">
            <span className="material-icons">notifications_none</span>
            <h3>No notifications</h3>
            <p>
              {filter === "unread" 
                ? "You're all caught up! No unread notifications." 
                : filter === "read"
                ? "No read notifications to show."
                : "No notifications available."}
            </p>
          </div>
        ) : (
          <div className="notifications-list">
            {filteredNotifications.map((notification) => (
              <div
                key={notification.id}
                className={`notification-card ${!notification.read ? "unread" : ""}`}
                onClick={() => markAsRead(notification.id)}
              >
                <div 
                  className="notification-card-icon"
                  style={{ backgroundColor: getNotificationColor(notification.type) + "20" }}
                >
                  <span 
                    className="material-icons"
                    style={{ color: getNotificationColor(notification.type) }}
                  >
                    {getNotificationIcon(notification.type)}
                  </span>
                </div>
                <div className="notification-card-content">
                  <div className="notification-card-header">
                    <h3 className="notification-card-title">{notification.title}</h3>
                    {!notification.read && (
                      <span className="notification-unread-badge">New</span>
                    )}
                  </div>
                  <p className="notification-card-message">{notification.message}</p>
                  <div className="notification-card-footer">
                    <span className="notification-card-time">
                      <span className="material-icons">schedule</span>
                      {notification.time}
                    </span>
                    <span className="notification-card-date">{notification.date}</span>
                  </div>
                </div>
                {!notification.read && (
                  <div className="notification-card-actions">
                    <button 
                      className="notification-mark-read-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        markAsRead(notification.id);
                      }}
                      title="Mark as read"
                    >
                      <span className="material-icons">check</span>
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Notifications;

